import { Box } from '@mui/material';
import usePaymentMethods from '../../hooks/queries/usePaymentMethods';
import useWindowSize from '../../hooks/useWindowSize';
import { RootState } from '../../store/config';
import { useAppSelector } from '../../store/hooks';
import { Commerce } from '../../types/commerce.type';
import { Vertical } from '../../types/verticals.type';
import Loading from '../Animations/Loading';
import PaymentMethodsList from './PaymentMethodsList';

interface PaymentMethodsStepProps {
  children: JSX.Element;
}

function PaymentMethodsStep({ children }: PaymentMethodsStepProps) {
  const { isMobile } = useWindowSize();
  const globalState = useAppSelector((state: RootState) => state);
  const vertical: Vertical | null = globalState.vertical.vertical;
  const commerce: Commerce | null = globalState.commerce.commerce;
  const { data: paymentMethods, isLoading } = usePaymentMethods(vertical?.verticalType, commerce?.commerceId);

  if (isLoading) return <Loading centered />;

  return (
    <>
      <Box
        className={
          isMobile && [0, 1, undefined].includes(paymentMethods?.issuers?.length)
            ? 'payment-methods-step'
            : 'single-payment-method-step'
        }
      >
        {children}
        <PaymentMethodsList />
      </Box>
    </>
  );
}

export default PaymentMethodsStep;
